// 主页面
import { request } from "./index.js";
import { getUserInfo } from '../sdk/utils.js';
const userInfo = getUserInfo(); // 用户信息
let PREFIX = ""; // "/prod-api";
if (userInfo.type == 'BXS') {
	PREFIX = '/businessapi'
}

/**
 * 获取聊天记录
 * @param {*} page 页码
 * @param {*} pageSize 每页数量
 * @param {*} customerId 客户id
 * @param {*} sceneId 场景id
 * @param {*} shopId 店铺id
 */
export const getChatHistory = (params) => {
	return request.get(PREFIX + "/im/customer/history", { params });
};

/**
 * 发送消息
 * @param {*} customerId 客户id
 * @param {*} businessUserId 推广员id 第一次通话不传 传参规则，家长传参："JZ_"+家长Id, 学生传参："XS_"+学生Id,推广员传参："TGY_"+推广员id
 * @param {*} shopId 店铺id
 * @param {*} msgContent 消息内容
 * @param {*} fileName 文件名 发送附件的时候传
 * @param {*} msgType 消息类型 普通的是传text，图片传image，文件传file
 */
export const sendMessage = (data) => {
	return request.post(PREFIX + "/im/customer/send", Object.assign(data));
};

/**
 * 会话列表
 * @param {*} page 页码
 * @param {*} pageSize 每页数量
 * @param {*} userId 客户id
 */
export const conversationList = (data) => {
	return request.post(PREFIX + "/goeasyIm/conversation", Object.assign(data));
};

/**
 * 标记已读客服消息
 * @param {*} customerId 客户id
 * @param {*} businessUserId 第一次通话不传
 * @param {*} sceneId 场景id
 */
export const markMsgRead = (data) => {
	return request.post(PREFIX + "/im/customer/markRead", Object.assign(data));
};

// 通讯录
/**
 * 分页查询好友列表
 * @param {*} customerId 客户id
 * @param {*} page 页码
 * @param {*} pageSize 每页数量
 * @param {*} keyword 手机、昵称查询
 */
export const queryFriendList = (data) => {
	return request.post(
		PREFIX + "/goeasyIm/queryFriendList",
		Object.assign(data),
	);
};

/**
 * 分页查询好友列表
 * @param {*} customerId 客户id
 * @param {*} page 页码
 * @param {*} pageSize 每页数量
 * @param {*} keyword 手机、昵称查询
 */
export const queryFriendApplyList = (data) => {
	return request.post(
		PREFIX + "/goeasyIm/queryFriendApplyList",
		Object.assign(data),
	);
};

/**
 * 处理好友申请
 * @param {*} applyId 好友申请id
 * @param {*} userId 当前登陆人id
 * @param {*} status 同意状态 0-申请中，1-已通过，2-已拒绝，3-已拉黑
 * @param {*} remark 备注
 */
export const handleFriendApply = (data) => {
	return request.post(
		PREFIX + "/goeasyIm/handleFriendApply",
		Object.assign(data),
	);
};

/**
 * 更新好友备注
 * @param {*} userId 客户id
 * @param {*} friendId 好友id
 * @param {*} remark 备注
 */
export const updateFriendRemark = (data) => {
	return request.post(PREFIX + "/goeasyIm/update", Object.assign(data));
};

/**
 * 搜索好友
 * @param {*} userId 客户id
 * @param {*} phone 手机号
 */
export const searchNewFriend = (params) => {
	return request.get(PREFIX + "/goeasyIm/search", { params });
};

/**
 * 申请添加好友
 * @param {*} userId 申请人id
 * @param {*} friendId 被申请人id
 * @param {*} note 留言
 * @param {*} remark 备注
 */
export const applyFriend = (data) => {
	return request.post(PREFIX + "/goeasyIm/applyFriend", Object.assign(data));
};

/**
 * 查询好友信息
 * @param {*} userId 客户id
 * @param {*} friendId 好友id
 */
export const getFriendInfo = (data) => {
	return request.post(PREFIX + "/goeasyIm/queryGroup", Object.assign(data));
};

/**
 * 删除好友
 * @param {*} userId 客户id
 * @param {*} friendId 好友id
 */
export const deleteFriend = (data) => {
	return request.post(PREFIX + "/goeasyIm/deleteFriend", Object.assign(data));
};

/**
 * 查询用户所在群聊列表
 * @param {*} userId 客户id
 * @param {*} groupName 群聊名称
 * @param {*} page 页码
 * @param {*} pageSize 每页数量
 */
export const queryGroupList = (data) => {
	return request.post(
		PREFIX + "/goeasyIm/queryUserGroupList",
		Object.assign(data),
	);
};

/**
 * 创建群聊
 * @param {*} groupName 群名称
 * @param {*} creatorId 创建人id/当前登陆人id
 * @param {*} avatar 创建人头像
 * @param {*} memberIds 群成员id列表 { friendId: 好友Id avatar: 好友头像 }
 */
export const createGroup = (data) => {
	return request.post(PREFIX + "/goeasyIm/createGroup", Object.assign(data));
};

/**
 * 加入群聊
 * @param {*} groupId 群id
 * @param {*} memberIds 群成员id列表 { friendId: 好友Id avatar: 好友头像 }
 */
export const addGroupMember = (data) => {
	return request.post(PREFIX + "/goeasyIm/addGroupMember", Object.assign(data));
};

/**
 * 查询群聊成员列表
 * @param {*} groupId 群id
 * @param {*} userId 当前登陆人
 * @param {*} name 昵称查询
 */
export const queryGroupMemberList = (data) => {
	return request.post(
		PREFIX + "/goeasyIm/queryGroupMemberList",
		Object.assign(data),
	);
};

/**
 * 更新群聊名称
 * @param {*} groupId 群id
 * @param {*} creatorId 创建人id
 * @param {*} groupName 群名称
 */
export const updateGroupName = (data) => {
	return request.post(
		PREFIX + "/goeasyIm/updateGroupName",
		Object.assign(data),
	);
};

/**
 * 解散群聊
 * @param {*} groupId 群id
 * @param {*} creatorId 创建人id
 */
export const dismissGroup = (data) => {
	return request.post(PREFIX + "/goeasyIm/dissolveGroup", Object.assign(data));
};

/**
 * 退出群聊
 * @param {*} userId 当前登陆人
 * @param {*} groupId 群id
 */
export const quitGroup = (data) => {
	return request.post(PREFIX + "/goeasyIm/quitGroup", Object.assign(data));
};

// 私聊/群聊
/**
 * 查询聊天记录
 * @param {*} sceneId 客户id
 * @param {*} groupId 群组id
 * @param {*} content 模糊查询
 * @param {*} page 页码
 * @param {*} pageSize 每页数量
 */
export const getImChatHistory = (data) => {
	return request.post(PREFIX + "/goeasyIm/queryHistory", Object.assign(data));
};

/**
 * 标记已读私聊消息
 * @param {*} msgId 消息id
 * @param {*} userId 接收人id-当前登陆人
 */
export const markAsRead = (data) => {
	return request.post(PREFIX + "/goeasyIm/markAsRead", Object.assign(data));
};

/**
 * 批量标记已读私聊消息
 * @param {*} toId 发送人id
 * @param {*} userId 当前登陆人id
 */
export const batchMarkAsRead = (data) => {
	return request.post(
		PREFIX + "/goeasyIm/batchMarkAsRead",
		Object.assign(data),
	);
};

/**
 * 标记已读群聊消息
 * @param {*} groupId 群id
 * @param {*} userId 接收人id-当前登陆人
 */
export const markGroupMsgAsRead = (data) => {
	return request.post(
		PREFIX + "/goeasyIm/batchMarkGroupMsgAsRead",
		Object.assign(data),
	);
};

/**
 * 发送私聊消息
 * @param {*} toId 接收人id
 * @param {*} userId 当前登陆人id
 * @param {*} groupId 群组id
 * @param {*} msgType 消息内容
 * @param {*} content 消息内容
 * @param {*} sceneId 场景id
 * @param {*} fileName 文件名
 */
export const sendImMessage = (data) => {
	return request.post(PREFIX + "/goeasyIm/sendMsg", Object.assign(data));
};

/**
 * 获取七牛云上传token
 * @param {*} fileName 文件名
 */
export const getQiniuToken = (data) => {
	return request({
		url: "/qiniu/getUpToken",
		method: "post",
		data,
	});
};

/**
 * 查询伴学师的学生列表
 * @param {*} shopId 
 * @param {*} page 
 * @param {*} pageSize 
 * @returns 
 */
export const getStudentList = (data) => {
	return request.get(PREFIX + "/yymAccompanyingTeacher/myBuyerUserList", Object.assign(data));
};

/**
 * 站内信未读数量
 * @param {object} params 如 { platform: 'wxy_pc' }
 * @returns {Promise<{ total?: number }>}
 */
export const getStationUnReadNum = (params) => {
	return request.get("/YymUserMessage/unreadCount", { params });
};

/**
 * 查询伴学师列表
 * @param {object} params 如 { page: 1, pageSize: 10 }
 * @returns {Promise<{ list: Array<{ id: number, name: string }> }>}
 */
export const getMyTeacherList = (params) => {
	return request.get("/yymAccompanyingQnaManagement/tutors", { params });
};